<div class="buffer-slider" #sliderContainer>
  <span class="label">{{ label }}:</span>
  <span class="value">{{ value }}</span>

  <mat-slider
    [disabled]="!!filterService.isBufferDisable"
    [min]="min"
    [max]="max"
    [step]="step"
    [value]="value"
    (input)="onValueChange($event.value||0)"
    thumbLabel="false"
    tickInterval="1"
    class="custom-slider">
  </mat-slider>
</div>
